var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightAlign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166016 15.5H15.166V13.8333H0.166016V15.5ZM5.16602 12.1667H15.166V10.5H5.16602V12.1667ZM0.166016 8.83333H15.166V7.16667H0.166016V8.83333ZM5.16602 5.5H15.166V3.83333H5.16602V5.5ZM0.166016 0.5V2.16667H15.166V0.5H0.166016Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAlign);
export default __webpack_public_path__ + "static/media/rightAlign.8aa2f2c7bf7f6fae9c235874fb05a382.svg";
export { ForwardRef as ReactComponent };